const expand = {
  position: { select: 'id,name' },
  dynamicEntity: { select: 'id,displayName' },
};

/**
 * OData select/expand for global entity approvers (by position).
 * Used by createCrudModel via CoreQueries.GlobalEntityApproverByPosition.
 */
export default {
  paged: {
    select: 'id,approvalLevel,entityValue,dynamicEntityFieldDisplayText',
    notSelectSearch: 'approvalLevel',
    expand,
  },
  item: {
    select:
      'id,approvalLevel,positionId,dynamicEntityId,dynamicEntityFieldId,dynamicEntityFieldDisplayText,dynamicEntityFieldInternalName,entityValue',
    expand,
  },
  itemDetail: {
    select:
      'id,approvalLevel,entityValue,updated,created,dynamicEntityId,dynamicEntityFieldId,dynamicEntityFieldDisplayText,dynamicEntityFieldInternalName',
    expand: {
      ...expand,
      userCreator: { select: 'fullName' },
      userModifier: { select: 'fullName' },
    },
  },
};
